import React from "react";
import { motion } from "framer-motion";

const strains = [
  {
    title: "Current Strain",
    name: "Bubba Kush",
    flavor: "Coffee, Pungent, Earthy, Woody",
    terpene: "Bisabolol, Caryophyllene, Humulene, Guaiol, Limonene",
    thc: "19-22%",
    image: "/images/bubba-kush.png",
  },
  {
    title: "Current Strain",
    name: "MK Ultra",
    flavor: "Earth, Pine, Woody, Pungent",
    terpene: "Myrcene, Caryophyllene, Camphene",
    thc: "18-22%",
    image: "/images/mk-ultra.png",
  },
  {
    title: "Current Strain",
    name: "Pink Kush",
    flavor: "Sweet, Floral, Vanilla, Earthy, Spice",
    terpene: "Myrcene, Limonene, Geraniol, Phellandrene",
    thc: "20-26%",
    image: "/images/pink-kush.png",
  },
  {
    title: "Upcoming Strain",
    name: "Chem de la Chem",
    flavor: "Sweet, Creamy, Earthy",
    terpene: "Limonene, Pinene, Farnesene",
    thc: "25-30%",
    image: "/images/chem-de-la-chem.png",
  },
  {
    title: "Upcoming Strain",
    name: "Kandy Kush",
    flavor: "Sweet, Floral, Vanilla, Earthy, Spice",
    terpene: "Myrcene, Limonene, Caryophyllene",
    thc: "24-27%",
    image: "/images/kandy-kush.png",
  },
  {
    title: "Upcoming Strain",
    name: "White Runtz",
    flavor: "Sweet, Floral, Vanilla, Earthy, Spice",
    terpene: "Limonene, Linalool, Caryophyllene",
    thc: "25-30%",
    image: "/images/white-runtz.png",
  },
];

const StrainsSection = () => {
  return (
    <section className="relative text-white py-16">
      {/* Vertical Sidebar */}
      <motion.div
        className="absolute left-0 top-0 h-full bg-green-500 text-black font-bold text-xl p-6 flex items-center writing-mode-vertical-rl"
        initial={{ x: -100, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <p className="tracking-wide text-lg md:text-xl">OUR STRAINS</p>
      </motion.div>

      {/* Content Wrapper */}
      <div className="container mx-auto pl-28 md:pl-32 pr-4">
        {/* Strain Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
          {strains.map((strain, index) => (
            <motion.div
              key={index}
              className="group relative rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-shadow duration-300"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, ease: "easeOut" }}
              viewport={{ once: true }}
            >
              <img
                src={strain.image}
                alt={strain.name}
                className="w-full h-72 object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/70 to-black opacity-75 group-hover:opacity-85 transition-opacity duration-300"></div>
              <div className="absolute inset-0 p-6 flex flex-col justify-end space-y-4">
                <h2 className="text-green-400 text-lg font-semibold">
                  {strain.title}
                </h2>
                <h3 className="text-2xl font-extrabold text-white">
                  {strain.name}
                </h3>
              </div>
              <motion.div
                className="absolute inset-0 bg-black bg-opacity-80 flex flex-col justify-center items-center opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                whileHover={{ scale: 1.05 }}
              >
                <h3 className="text-xl font-bold text-green-400 mb-4">
                  {strain.name}
                </h3>
                <p className="text-center text-base md:text-lg text-gray-300 mb-2 px-4">
                  <span className="font-bold">Flavor:</span> {strain.flavor}
                </p>
                <p className="text-center text-base md:text-lg text-gray-300 mb-2 px-4">
                  <span className="font-bold">Terpenes:</span> {strain.terpene}
                </p>
                <p className="text-center text-base md:text-lg text-gray-300">
                  <span className="font-bold">THC:</span> {strain.thc}
                </p>
              </motion.div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StrainsSection;
